import { Country } from '../country.model';
import { Building } from '../room-booking/building.model';
import { RoomBooking } from '../room-booking/room-booking.model';
import { ServiceBooking } from '../room-booking/service-booking.model';

export class Member {
  /* Data from Exchange API */
  id?: string;
  roles: string[];
  workplace?: string | Building;
  country?: string | Country;
  createdAt?: string;
  updatedAt?: string;
  serviceBookings?: string[] | ServiceBooking[];
  roomBookings?: string[] | RoomBooking[];

  constructor(values= {}) {
    Object.assign(this, values);
  }

  /**
   * Returns this user's full name used for displaying information
   */
  getFullName(): string {
    return this['displayName'] || this['display_name'] || (this['firstName'] + ' ' + this['lastName']);
  }

  getEmail(): string {
    return this['emailAddress'] || this['email'] || this['mail'][0];
  }

  toString() {
    return this.getFullName();
  }
}
